
import DataTable from '../../components/DataTable/DataTable';
import { Spinner } from "react-bootstrap";
import Icon from '../Icon/Icon';
import { Row, Col, Button } from "react-bootstrap";


const docDeleteclick=(state)=>{
alert(state.name);
console.log(state.name);
}

export const tableColumns = [    
        {
            name: "Documents",
            selector: (row) => row.name,
            sortable: true,            
          },   
          {
            name : "Created On",
            selector : (row) => row.dateCreated,
            sortable:true,
          }, 
          {
            name : "Last Modified On",
            selector : (row) => row.dateModified,
            sortable:true,
          },
          // {
          //   name : "",
          //   sortable :false,
            
          // }, 
          // {
          //   name: "",
          //   selector: (row) =>{
          //       return (           
          //           <span>
          //           <a href={row.uri} download target={'_blank'} ><Icon name="file-download"></Icon> Download</a> | <Icon name="cross-circle"></Icon> <a herf="" >Delete</a>
          //           </span>
          //       )
               
          //   },
          //   sortable: true,
          // }, 
          // { 
          //   name : "",
          //   selector : (row) => <Button onclick={()=>docDeleteclick(row)} >Delete</Button> ,
          //   button:true,
          // }, 
        //   {
        //     name: "contentType",
        //     selector: (row) => row.contentType,
        //     sortable: true,
        //   }, 
    ];





const FileListing = ({data, detailSelect}) => {
   

    if(!data) (
        <Spinner animation="border" variant="primary" />
    );

    //console.log(data);

if(data)
  return (    
<>
     <DataTable 
      tableClassName="data-table-head-light table-responsive" 
      pointerOnHover={true} 
      data={data} 
      columns={tableColumns}
      striped={true} 
      highlightOnHover={true} 
      filterFieldName={"name"} 
      onRowClicked={(row,event)=>{ detailSelect(row) }} 
      />    
     </>
  )
}

export default FileListing